import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */
import { CollapseBuilder } from "./CollapseBuilder";
import { Configuration } from "../Shared/Configuration";
import { DateTimeFormatter } from "./DateTimeFormatter";
import { UrlUtils } from "../Shared/UrlUtils";
import { TextFormatter } from "./TextFormatter";
export var CardBuilder = /*#__PURE__*/function () {
  function CardBuilder() {
    _classCallCheck(this, CardBuilder);
  }

  _createClass(CardBuilder, null, [{
    key: "BuildBadge",
    value: function BuildBadge(isBadge, badgeText) {
      var cardClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "mpp-card";

      if (isBadge) {
        return "<span class=\"".concat(cardClass, "--badge ").concat(badgeText, "\">").concat(!!badgeText ? badgeText : "", "</span>");
      } else {
        return "";
      }
    }
  }, {
    key: "BuildImage",
    value: function BuildImage(imageUrl, type) {
      var src = imageUrl;
      var style = "";

      if (imageUrl === null || imageUrl === undefined) {
        src = "".concat(new Configuration().GetAppRoot(), "/Content/icons/icon-").concat(type, ".svg");
        style = "margin:40px;height:80px;width:80px;";
      }

      return "<img class=\"mpp-card--image\" src=\"".concat(src, "\" style=\"").concat(style, "\" />");
    }
  }, {
    key: "BuildCloudAppDetailsButton",
    value: function BuildCloudAppDetailsButton(id, targetUrl, btnText) {
      if (!!targetUrl) {
        var finalTargetUrl = "".concat(targetUrl).concat(id);
        return "<a href=\"".concat(finalTargetUrl, "\" target=\"_blank\" id=\"").concat(id, "\" class=\"mppw-btn primary buildDetailsButton\">").concat(btnText, "</a>");
      } else {
        return "";
      }
    }
  }, {
    key: "BuildDetailsButton",
    value: function BuildDetailsButton(id, targetUrl, btnText) {
      var idParameterName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return !!targetUrl ? "<a href=\"".concat(targetUrl, "\" ").concat(idParameterName !== null && idParameterName !== void 0 ? idParameterName : "id", "=\"").concat(id, "\" class=\"mppw-btn primary buildDetailsButton\">").concat(btnText, "</a>") : "";
    }
  }, {
    key: "BuildButtons",
    value: function BuildButtons(buttons) {
      return "<div class=\"buttons--container\">\n\t\t\t".concat(buttons.map(function (button) {
        return "<button class=\"mppw-btn ".concat(button["type"], "\">").concat(button["text"], "</button>");
      }).join(""), "\n\t\t</div>");
    }
  }, {
    key: "BuildText",
    value: function BuildText(title) {
      var subtitles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var description = arguments.length > 2 ? arguments[2] : undefined;
      return "<div class=\"text--container\">\n\t\t\t<h3 class=\"mpp-card--title\">".concat(title, "</h3>\n\t\t\t").concat(subtitles.map(function (subtitle) {
        return "<h4 class=\"mpp-card--subtitle ".concat(subtitle.className, "\">").concat(subtitle.text, "</h4>");
      }).join(""), "\n\t\t\t<div class=\"mpp-card--description\">").concat(description === null ? "" : new TextFormatter(description).addLineBreaks().normalizeHtml().value, "</div>\n\t\t</div>");
    }
  }, {
    key: "BuildTextRow",
    value: function BuildTextRow() {
      var subtitles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return "<div class=\"text--container\">\n\t\t\t".concat(subtitles.map(function (subtitle) {
        return "<div class=\"mpp-card-row--subtitle ".concat(subtitle.className, "\">").concat(subtitle.text, "</div>");
      }).join(""), "\n\t\t</div>");
    }
  }, {
    key: "BuildProgress",
    value: function BuildProgress() {
      var header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "$750 of $1,000 Goal (75%)";
      var percentage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "75";
      var description = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "12 installments beginning 05/15/2019";
      return "<div class=\"progress--container\">\n\t\t\t<h3 class=\"progress--subtitle\">".concat(header, "</h3>\n\t\t\t<svg class=\"mpp-card--progress\" width=\"100%\" height=\"15\">\n\t\t\t\t<defs>\n\t\t\t\t\t<linearGradient id=\"gradient\">\n\t\t\t\t\t\t<stop offset=\"0%\" stop-color=\"#1b88b0\" />\n\t\t\t\t\t\t<stop offset=\"100%\" stop-color=\"#1fb5ac\" />\n\t\t\t\t\t</linearGradient>\n\t\t\t\t</defs>\n\t\t\t\t<g>\n\t\t\t\t\t<rect fill=\"#efefef\" width=\"100%\" height=\"15\"></rect>\n\t\t\t\t\t<rect fill=\"url(#gradient)\" width=\"").concat(percentage, "%\" height=\"15\"></rect>\n\t\t\t\t</g>\n\t\t\t</svg>\n\t\t\t<p class=\"mpp-card--description\">").concat(description, "</p>\n\t\t</div>");
    }
  }, {
    key: "BuildProgressRow",
    value: function BuildProgressRow(header, progressHeader) {
      var percentage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "75";
      var description = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "12 installments beginning 05/15/2019";
      return "<div class=\"progress--container\">\n\t\t\t<div class=\"progress-row--subtitle\">".concat(header, "</div>\n\t\t\t<div class=\"progress-row--main\">\n\t\t\t\t<div class=\"progress-row--detail\">\n\t\t\t\t\t<div class=\"progress-row--detail-label\">\n\t\t\t\t\t\t").concat(progressHeader, "\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"progress-row--detail-bar\">\n\t\t\t\t\t\t<svg class=\"mpp-card-row--progress\" width=\"100%\" height=\"15\">\n\t\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t\t\t<linearGradient id=\"gradient\">\n\t\t\t\t\t\t\t\t\t<stop offset=\"0%\" stop-color=\"#79B70E\" />\n\t\t\t\t\t\t\t\t\t<stop offset=\"100%\" stop-color=\"#79B70E\" />\n\t\t\t\t\t\t\t\t</linearGradient>\n\t\t\t\t\t\t\t</defs>\n\t\t\t\t\t\t\t<g>\n\t\t\t\t\t\t\t\t<rect fill=\"#dddddd\" width=\"100%\" height=\"15\"></rect>\n\t\t\t\t\t\t\t\t<rect fill=\"url(#gradient)\" width=\"").concat(percentage, "%\" height=\"15\"></rect>\n\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>");
    }
  }, {
    key: "BuildCard",
    value: function BuildCard(header, body, footer, targetUrl) {
      var isTransparent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      return "<div class=\"mpp-card\" onclick=\"".concat(targetUrl ? 'window.location.href=\'' + targetUrl + '\'' : "", "\">\n\t\t\t<div class=\"mpp-card--header ").concat(isTransparent ? "mpp-card--transparent" : "", "\">\n\t\t\t\t").concat(header, "\n\t\t\t</div>\n\t\t\t<div class=\"mpp-card--body\">\n\t\t\t\t").concat(body, "\n\t\t\t</div>\n\t\t\t<div class=\"mpp-card--footer\">\n\t\t\t\t").concat(footer, "\n\t\t\t</div>\n\t\t</div>");
    }
  }, {
    key: "BuildCardRow",
    value: function BuildCardRow(headerBadge, headerImage, campaignName, tripDatesText, body, footer) {
      var CardRowToggle = function CardRowToggle() {
        var itemDown = element.querySelector(".mpp-card-row--svg-down");
        var itemUp = element.querySelector(".mpp-card-row--svg-up");
        var details = element.querySelector(".mpp-card-row-transition");
        var main = element.querySelector(".mpp-card-row--main");
        var isHidden = itemDown.classList.contains("hidden");

        if (isHidden) {
          itemDown.classList.remove("hidden");
          itemUp.classList.add("hidden");
          details.classList.remove("mpp-card-row-transition-expanded");
          main.classList.remove("mpp-card-row-expanded--main");
        } else {
          itemDown.classList.add("hidden");
          itemUp.classList.remove("hidden");
          details.classList.add("mpp-card-row-transition-expanded");
          main.classList.add("mpp-card-row-expanded--main");
        }
      };

      var element = document.createElement("div");
      element.innerHTML = "<div class=\"mpp-card-row\">\n\t\t\t<div class=\"mpp-card-row--main\">\n\t\t\t\t<div class=\"mpp-card-row--header\">\n\t\t\t\t\t".concat(headerImage, "\n\t\t\t\t\t").concat(headerBadge, "\n\t\t\t\t\t<div class=\"mpp-card-row--details\">\n\t\t\t\t\t\t<div class=\"mpp-card-row--title\">").concat(campaignName, "</div>\n\t\t\t\t\t\t<div class=\"mpp-card-row--dates\">").concat(tripDatesText, "</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mpp-card-row--body\">\n\t\t\t\t\t").concat(body, "\n\t\t\t\t\t<div class=\"mpp-card-row--collapsed\">\n\t\t\t\t\t\t<div class=\"mpp-card-row--svg-down\">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n\t\t\t\t\t\t\t<!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n\t\t\t\t\t\t\t<path d=\"M207 381.5L12.7 187.1c-9.4-9.4-9.4-24.6 0-33.9l22.7-22.7c9.4-9.4 24.5-9.4 33.9 0L224 284.5l154.7-154c9.4-9.3 24.5-9.3 33.9 0l22.7 22.7c9.4 9.4 9.4 24.6 0 33.9L241 381.5c-9.4 9.4-24.6 9.4-33.9 0z\"/></svg>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"mpp-card-row--svg-up hidden\">\n\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\">\n\t\t\t\t\t\t\t<!--!Font Awesome Free 6.6.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.-->\n\t\t\t\t\t\t\t<path d=\"M241 130.5l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9l-22.7 22.7c-9.4 9.4-24.5 9.4-33.9 0L224 227.5 69.3 381.5c-9.4 9.3-24.5 9.3-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.6 0-33.9L207 130.5c9.4-9.4 24.6-9.4 33.9 0z\"/></svg>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"mpp-card-row--footer\">\n\t\t\t\t<div class=\"mpp-card-row-transition\">\n\t\t\t\t\t<div class=\"mpp-card-row-transition-div\">\n\t\t\t\t\t\t").concat(footer, "\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>");
      element.querySelector(".mpp-card-row--collapsed").addEventListener("click", function () {
        return CardRowToggle();
      });
      return element;
    }
  }, {
    key: "BuildCardRowFooter",
    value: function BuildCardRowFooter(i, imageUrl, details) {
      return "<div class=\"mpp-card-row-details\">\n\t\t\t".concat(details, "\n\t\t</div>");
    }
  }, {
    key: "BuildUrl",
    value: function BuildUrl(targetUrl, id) {
      var idParameterName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var targetParams = {};

      if (idParameterName) {
        targetParams[idParameterName] = id;
      } else {
        targetParams["id"] = id;
      }

      return !!targetUrl ? UrlUtils.AddQueryStringParams(targetUrl, targetParams) : null;
    }
  }, {
    key: "BuildCheckbox",
    value: function BuildCheckbox(uniqueId, isChecked) {
      var cardClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "mpp-card";
      return "<label class=\"".concat(cardClass, "-multiselect--checkbox\">\n\t\t\t<input type=\"checkbox\" id=\"").concat(uniqueId, "\" name=\"publications\" value=\"").concat(uniqueId, "\" ").concat(isChecked ? "checked" : "", " />\n\t\t\t<span></span>\n\t\t</label>");
    }
  }, {
    key: "BuildSubscriptionCheckbox",
    value: function BuildSubscriptionCheckbox(uniqueId, isChecked) {
      var cardClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "mpp-card";
      return "<label class=\"".concat(cardClass, "-multiselect--checkbox\">\n\t\t\t<input type=\"checkbox\" id=\"").concat(uniqueId, "\" name=\"bulkemailoptout\" value=\"").concat(isChecked, "\" ").concat(isChecked ? "checked" : "", " />\n\t\t\t<span style=\"float: left;\"></span>\n\t\t</label>");
    }
  }, {
    key: "BuildPills",
    value: function BuildPills() {
      var labels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var cardClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "mpp-card";
      labels = labels.filter(function (i) {
        return i;
      });
      return "<ul class=\"".concat(cardClass, "--labels\">\n\t\t\t").concat(labels.map(function (label) {
        return "<li class=\"mpp-card--label\">".concat(label, "</li>");
      }).join(""), "\n\t\t</ul>");
    }
  }, {
    key: "BuildMyInvoicesSubtitlesArr",
    value: function BuildMyInvoicesSubtitlesArr() {
      var invoiceDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var invoiceTotal = arguments.length > 1 ? arguments[1] : undefined;
      var invoiceStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var subtitlesArr = [];

      if (!!invoiceDate) {
        subtitlesArr.push({
          className: "invoice-date",
          text: "".concat(new DateTimeFormatter().ToShortDateFormatted(invoiceDate, true))
        });
      }

      if (!!invoiceTotal) {
        var total = "$".concat(Number(invoiceTotal).toFixed(2).toLocaleString());
        subtitlesArr.push({
          className: "invoice-total",
          text: total
        });
      }

      if (!!invoiceStatus) {
        subtitlesArr.push({
          className: "invoice-status",
          text: "".concat(invoiceStatus)
        });
      }

      return subtitlesArr;
    }
  }, {
    key: "BuildGroupSubtitlesArr",
    value: function BuildGroupSubtitlesArr() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var meetingDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var meetingTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var startDate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
      var alreadyMeetingText = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "Already Meeting";
      var capacityTitle = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "";
      var capacityLabel = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "";
      var dateTimeFormatter = new DateTimeFormatter();
      var subtitlesArr = [];
      if (!!location) subtitlesArr.push({
        className: "group-location",
        text: location
      });

      if (!!meetingDay) {
        if (meetingDay.length) subtitlesArr.push({
          className: "group-meeting-day",
          text: "".concat(meetingDay, " ").concat(meetingTime !== null ? "@ ".concat(dateTimeFormatter.ToShortTime(meetingTime)) : "")
        });
      }

      if (!!capacityLabel) {
        subtitlesArr.push({
          className: "group-capacity",
          text: capacityTitle + ": " + capacityLabel
        });
      }

      if (!!startDate) {
        if (startDate.length) subtitlesArr.push({
          className: "group-start-date",
          text: "".concat(dateTimeFormatter.IsInThePast(startDate) ? alreadyMeetingText : "Starts: ".concat(dateTimeFormatter.ToShortDate(startDate)))
        });
      }

      return subtitlesArr;
    }
  }, {
    key: "BuildOpportunitySubtitlesArr",
    value: function BuildOpportunitySubtitlesArr() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var meetingDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var startDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var subtitlesArr = []; // need logic to prioritize 'Location', 'Location Name or Congregation Name', 'Congregation Name from Program'
      // location is coming in as Congregation Name from Program

      subtitlesArr.push({
        className: "opportunity-location",
        text: location
      });
      subtitlesArr.push({
        className: "opportunity-start-date",
        text: startDate === null ? meetingDay : "".concat(new DateTimeFormatter().ToShortDateTime(startDate))
      });
      return subtitlesArr;
    }
  }, {
    key: "BuildEventSubtitlesArr",
    value: function BuildEventSubtitlesArr() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var startDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var endDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var dateTimeFormatter = new DateTimeFormatter();
      var subtitlesArr = [];
      subtitlesArr.push({
        className: "event-date-range",
        text: dateTimeFormatter.ToShortDateTimeRange(startDate, endDate)
      });

      if (location) {
        subtitlesArr.push({
          className: "event-location",
          text: location
        });
      }

      return subtitlesArr;
    }
  }, {
    key: "BuildMissionTripSubtitlesArr",
    value: function BuildMissionTripSubtitlesArr() {
      var congregation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var tripStartDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      var tripEndDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var maximumRegistrants = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var currentRegistrants = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var dateTimeFormatter = new DateTimeFormatter();
      var subtitlesArr = [];
      subtitlesArr.push({
        className: "mission-trip-congregation",
        text: congregation
      });

      if (tripStartDate && tripEndDate) {
        subtitlesArr.push({
          className: "mission-trip-date-range",
          text: "Trip Dates: ".concat(dateTimeFormatter.ToShortDateFormatted(tripStartDate, true), " through ").concat(dateTimeFormatter.ToShortDateFormatted(tripEndDate, true))
        });
      }

      if (maximumRegistrants > 0) {
        subtitlesArr.push({
          className: "mission-trip-full",
          text: currentRegistrants >= maximumRegistrants ? "Capacity: FULL" : "Capacity: ".concat(currentRegistrants, " of ").concat(maximumRegistrants)
        });
      }

      return subtitlesArr;
    }
  }, {
    key: "BuildMultiSelectCard",
    value: function BuildMultiSelectCard(index, imageUrl, title, publicationId, description, subscribed, noDescriptionText, showDescriptionText, hideDescriptionText) {
      return "<div class=\"mpp-card-multiselect card-".concat(index, "\">\n\t\t\t<img class=\"mpp-card-multiselect--image ").concat(imageUrl === null ? "mpp-card-multiselect--image-placeholder" : "", "\" src=\"").concat(imageUrl === null ? "".concat(new Configuration().GetAppRoot(), "/Content/icons/icon-email.svg") : imageUrl, "\" />\n\t\t\t<div class=\"mpp-card-multiselect--body\">\n\t\t\t\t<div class=\"mpp-card-multiselect--text-wrapper\">\n\t\t\t\t\t<h3 class=\"mpp-card-multiselect--title\">").concat(title, "</h3>\n\t\t\t\t\t").concat(CollapseBuilder.BuildCollapse(publicationId, description, noDescriptionText, showDescriptionText, hideDescriptionText), "\n\t\t\t\t</div>\n\t\t\t\t").concat(this.BuildCheckbox(publicationId, subscribed), "\n\t\t\t</div>\n\t\t</div>");
    }
  }]);

  return CardBuilder;
}();